import "./processing-indicator.scss";
import LinearLoader from "../../../../../components/loaders/linear-loader/linear-loader";

interface LoaderProps {
    isProcessing: boolean;
}
const ProcessingIndicator: React.FC<LoaderProps> = ({ isProcessing }) => {
    return (
        isProcessing
            ? <div className="processing-indicator">
                <LinearLoader />
            </div>
            : null
    );
};

export default ProcessingIndicator;
